import { apiSlice } from "./index";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
import {
    upsertTicket,
    upsertTickets,
    upsertTicketItems,
    upsertTicketItemsPeriod,
    childLevels,
    Ticket,
    TicketEditRequest,
    TicketItem,
    ShiftPlannedStartsRequest,
} from "../features/ticket/ticketSlice";
import { Filter } from "../features/filter/filterSlice";

export interface TicketResponse {
    ticket: Ticket | null;
    ticket_items: { [key: string]: TicketItem };
    errors: string[];
}

export interface TicketItemsResponse {
    tickets: { [key: string]: Ticket };
    ticket_items: { [key: string]: TicketItem };
    errors: string[];
}

type Levels = {
    level_1: boolean;
    level_2: boolean;
    level_3: boolean;
    level_4: boolean;
    level_5: boolean;
    level_6: boolean;
};

export function levelsToQuery(ktype: string): string {
    let levels = childLevels(ktype);
    const params = Object.entries(levels)
        .filter(([, value]) => value)
        .map(([key]) => `${encodeURIComponent(key)}=true`);

    return params.length ? `?${params.join("&")}` : "";
}

function filterToQuery(f: Filter): string {
    return "";
}

const filterApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        viewPost: builder.mutation<TicketItemsResponse, Filter>({
            query: (body) => {
                const idStr = body.id ? "/" + body.id : "";
                return {
                    url: "/filter/view-post" + idStr,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(upsertTicketItems(data.ticket_items));
                    /* if (data.ticket) {
                        } */
                } catch (err) {
                    console.log("202411301427: edit ticket api error", err);
                }
            },
        }),
        ticketViewUrl: builder.query({
            //query: (id) => `ticket/items-view/${id}?planned_start_after=2024-08-15T12:00:00Z`,
            query: (f: Filter) => `filter/view/${f.id}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("ticket query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    dispatch(upsertTicketItems(data.ticket_items));
                    dispatch(upsertTicket(data.ticket));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
        ticketItems: builder.query({
            //query: (id) => `ticket/items-view/${id}?planned_start_after=2024-08-15T12:00:00Z`,
            query: (id) => `ticket/items-view/${id}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("ticket query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    dispatch(upsertTicketItems(data.ticket_items));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
    }),
});

export const {
    useViewPostMutation,
    useTicketViewUrlQuery,
    useTicketItemsQuery,
} = filterApi;
